import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import {
  Container,
  Grid,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import CancellationReasonsCardPreview from './CancellationReasonsCardPreview';
import CreateCancellationReasonsForm from './CreateCancellationReasonsForm';
import CancellationReasonsService from '../../../services/CancellationReasonsService';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const CreateCancellationReasonsView = ({ edit }) => {
  const classes = useStyles();
  const { id } = useParams();
  const [cancellationReasons, setCancellationReasons] = useState({
    id: null,
    title: '',
    description: ''
  });

  const handleCancellationReasonsAttributes = (values) => {
    setCancellationReasons({
      ...cancellationReasons,
      ...values
    });
  };

  useEffect(() => {
    if (id) {
      (async () => {
        const response = await CancellationReasonsService.getById(id);
        if (response?.code === 200) {
          setCancellationReasons({
            ...response.data
          });
        }
      })();
    }
  }, [id]);

  return (
    <Page
      className={classes.root}
      title="Crear Razón de cancelación"
    >
      <Container maxWidth="lg">
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            lg={4}
            md={6}
            xs={12}
          >
            <CancellationReasonsCardPreview
              cancellationReasons={cancellationReasons}
            />
          </Grid>
          <Grid
            item
            lg={8}
            md={6}
            xs={12}
          >
            <CreateCancellationReasonsForm
              edit={edit}
              CancellationReasons={cancellationReasons}
              onChange={handleCancellationReasonsAttributes}
            />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

CreateCancellationReasonsView.propTypes = {
  edit: PropTypes.bool,
};

CreateCancellationReasonsView.defaultProps = {
  edit: false
};

export default CreateCancellationReasonsView;
